import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from './Header';
import mehmetAyseImage from '../assets/mehemtayse.png';
import cansuAliImage from '../assets/cansuvealikart.png';
import birthdayImage from '../assets/birthdaykart.png';
import ahmet15Image from '../assets/ahmet15.png';
import eventImage1 from '../assets/eventkart.png';
import eventImage2 from '../assets/eventkart2.png';

const Works = () => {
    const [activeFilter, setActiveFilter] = useState('all');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 9;
    const navigate = useNavigate();
    const location = useLocation();

    // Çalışma örnekleri verisi
    const allWorks = [
        {
            id: 1,
            title: "Mehmet & Ayşe",
            subtitle: "Düğün Ve Nişan Davetiyesi",
            category: "wedding",
            image: mehmetAyseImage,
            date: "2025",
            description: "Romantik ve şık düğün davetiyesi tasarımı",
            features: ["Hareketli Animasyonlar", "Geri Sayım", "Konum", "Tarih", "Müzik", "Dilek Mesajı"],
            color: "from-pink-100 to-rose-100"
        },

        {
            id: 3,
            title: "Ayşe'nin 2. Yaşı",
            subtitle: "Doğum Günü",
            category: "birthday",
            image: birthdayImage,
            date: "2025",
            description: "Renkli ve eğlenceli doğum günü davetiyesi",
            features: ["Hareketli Animasyonlar", "Müzik", "Konum", "Tarih", "Geri Sayım", "Sesli Dilek ", "Etkileşimli Animasyonlar"],
            color: "from-yellow-100 to-orange-100"
        },
        {
            id: 4,
            title: "Fatma'nın Kınası",
            subtitle: "Kına Gecesi",
            category: "henna",
            image: "/api/placeholder/300/400",
            date: "2025",
            description: "Geleneksel motiflerle süslenmiş kına davetiyesi",
            features: ["Motifler", "Müzik", "Dans", "Yemek"],
            color: "from-amber-100 to-yellow-100"
        },
        {
            id: 5,
            title: "Kurumsal Etkinlik 2025",
            subtitle: "Kurumsal Etkinlik",
            category: "corporate",
            image: eventImage2,
            date: "2025",
            description: "Profesyonel kurumsal etkinlik davetiyesi",
            features: ["Tarih & Saat", "Mekan", "Ek Bilgiler", "Konum"],
            color: "from-slate-100 to-gray-100"
        },
        {
            id: 6,
            title: "Sınıf 2024",
            subtitle: "Mezuniyet Töreni",
            category: "graduation",
            image: "/api/placeholder/300/400",
            date: "2025",
            description: "Özel mezuniyet töreni davetiyesi",
            features: ["Anılar", "Video", "Sertifika", "Kutlama"],
            color: "from-emerald-100 to-green-100"
        },
        {
            id: 7,
            title: "Cansu & Ali",
            subtitle: "Düğün Ve Nişan Davetiyesi",
            category: "wedding",
            image: cansuAliImage,
            date: "2025",
            description: "Vintage tarzda düğün davetiyesi",
            features: ["Vintage", "Müzik", "Konum", "RSVP"],
            color: "from-rose-100 to-pink-100"
        },
        {
            id: 8,
            title: "Mehmet'in 30. Yaşı",
            subtitle: "Doğum Günü",
            category: "birthday",
            image: "/api/placeholder/300/400",
            date: "2025",
            description: "Erkek doğum günü için özel tasarım",
            features: ["Oyunlar", "Müzik", "Sürpriz", "Fotoğraf"],
            color: "from-blue-100 to-cyan-100"
        },
        {
            id: 11,
            title: "Ahmet'in 15. Yaşı",
            subtitle: "Doğum Günü",
            category: "birthday",
            image: ahmet15Image,
            date: "2025",
            description: "Renkli ve eğlenceli doğum günü davetiyesi",
            features: ["Hareketli Animasyonlar", "Müzik", "Konum", "Tarih", "Geri Sayım", "Sesli Dilek ", "Etkileşimli Animasyonlar"],
            color: "from-green-100 to-emerald-100"
        },
        {
            id: 12,
            title: "Ahmet'in 25. Yaşı",
            subtitle: "Doğum Günü - 80'ler Teması",
            category: "birthday",
            image: "/api/placeholder/300/400",
            date: "2025",
            description: "Nostaljik 80'ler temalı retro doğum günü davetiyesi",
            features: ["80'ler Müzikleri", "Retro Tasarım", "Neon Renkler", "Pixel Animasyonlar", "Polaroid Galerisi", "Kaset Çalar"],
            color: "from-purple-100 to-pink-100"
        },
        {
            id: 13,
            title: "Ayşe'nin 25. Yaşı",
            subtitle: "Zarif Doğum Günü Kutlaması",
            category: "birthday",
            image: "/api/placeholder/300/400",
            date: "2025",
            description: "Şık ve minimalist yetişkin doğum günü davetiyesi",
            features: ["Zarif Tipografi", "Minimalist Tasarım", "İnteraktif Animasyonlar", "Rose Gold Detaylar", "Premium Deneyim", "Lüks Hissiyat"],
            color: "from-rose-50 to-pink-50"
        },
        {
            id: 9,
            title: "Startup Launch",
            subtitle: "Kurumsal Etkinlik",
            category: "corporate",
            image: "/api/placeholder/300/400",
            date: "2025",
            description: "Girişim lansmanı için modern tasarım",
            features: ["Demo", "Network", "Sunum", "Kokteyl"],
            color: "from-indigo-100 to-purple-100"
        },
        {
            id: 10,
            title: "Ahmet'in Sünneti",
            subtitle: "Sünnet Düğünü",
            category: "circumcision",
            image: "/api/placeholder/300/400",
            date: "2025",
            description: "Eğlenceli ve renkli sünnet düğünü davetiyesi",
            features: ["Oyunlar", "Müzik", "Hediye", "Fotoğraf"],
            color: "from-blue-100 to-indigo-100"
        }
    ];

    const categories = [
        { id: 'all', name: 'Tümü', count: allWorks.length },
        { id: 'wedding-engagement', name: 'Düğün & Nişan', count: allWorks.filter(w => w.category === 'wedding' || w.category === 'engagement').length },
        { id: 'birthday', name: 'Doğum Günü', count: allWorks.filter(w => w.category === 'birthday').length },
        { id: 'henna', name: 'Kına', count: allWorks.filter(w => w.category === 'henna').length },
        { id: 'corporate', name: 'Kurumsal', count: allWorks.filter(w => w.category === 'corporate').length },
        { id: 'graduation', name: 'Mezuniyet', count: allWorks.filter(w => w.category === 'graduation').length },
        { id: 'circumcision', name: 'Sünnet', count: allWorks.filter(w => w.category === 'circumcision').length }
    ];

    // Filtrelenmiş çalışmalar
    const filteredWorks = activeFilter === 'all'
        ? allWorks
        : activeFilter === 'wedding-engagement'
            ? allWorks.filter(work => work.category === 'wedding' || work.category === 'engagement')
            : allWorks.filter(work => work.category === activeFilter);

    // Sayfalama
    const totalPages = Math.ceil(filteredWorks.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentWorks = filteredWorks.slice(startIndex, endIndex);

    // Sayfa yüklendiğinde scroll'u en üste al
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // URL parametresinden kategori filtresi oku
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const category = urlParams.get('category');
        if (category) {
            setActiveFilter(category);
            setCurrentPage(1);
        }
    }, [location]);

    const handleFilterChange = (filter) => {
        setActiveFilter(filter);
        setCurrentPage(1);
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-primary-50">
            <Header />

            {/* Hero Section */}
            <section className="relative py-16 lg:py-20 overflow-hidden">
                {/* Arka plan dekoratif elementler */}
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute top-20 left-10 w-32 h-32 bg-primary-200 rounded-full opacity-10 animate-float"></div>
                    <div className="absolute bottom-20 right-10 w-24 h-24 bg-dark-200 rounded-full opacity-15 animate-pulse-slow"></div>
                    <div className="absolute top-1/4 right-1/3 w-16 h-16 bg-primary-100 rounded-full opacity-20 animate-bounce-slow"></div>
                </div>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                    <div className="text-center mb-10 animate-fade-in">
                        <div className="inline-block bg-gradient-to-r from-primary-100 to-primary-200 text-primary-800 px-6 py-3 rounded-full text-sm font-semibold mb-6 shadow-lg">
                            🎨 Portföyümüz
                        </div>
                        <h1 className="text-4xl lg:text-5xl font-bold text-dark-900 mb-6 animate-slide-up">
                            Çalışmalarımız
                        </h1>
                        <p className="text-lg text-dark-600 max-w-3xl mx-auto leading-relaxed animate-slide-up px-4 md:px-8 py-2 bg-white/50 backdrop-blur-sm rounded-xl shadow-sm" style={{ animationDelay: '0.2s' }}>
                            Müşterilerimizin <span className="text-primary-700 font-medium">özel anları</span> için özenle tasarladığımız
                            dijital davetiyelerimizi keşfedin. Her bir çalışmamız, <span className="text-primary-700 font-medium">modern estetik</span> ve
                            <span className="text-primary-700 font-medium"> kullanıcı dostu</span> deneyimi bir araya getiriyor.
                        </p>
                    </div>

                    {/* Kategori Filtreleri */}
                    <div className="animate-slide-up" style={{ animationDelay: '0.4s' }}>
                        {/* Desktop için kategori filtreleri */}
                        <div className="hidden lg:flex flex-wrap justify-center gap-2 mb-6">
                            {categories.map((category) => {
                                const getCategoryIcon = (categoryId) => {
                                    switch (categoryId) {
                                        case 'all':
                                            return (
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                                </svg>
                                            );
                                        case 'wedding-engagement':
                                            return (
                                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                                                </svg>
                                            );
                                        case 'birthday':
                                            return (
                                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 1l-1.71 1.97c-.19.3-.29.65-.29 1.03 0 1.1.89 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07L7.4 15.99C8.7 17.3 10.98 17.3 12.28 16c1.3 1.3 3.58 1.3 4.89 0-.01 0-.01 0 0 0zM12 9c-4.97 0-9 1.67-9 3.75V16c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-3.25C21 10.67 16.97 9 12 9z" />
                                                </svg>
                                            );
                                        case 'henna':
                                            return (
                                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2M21 9V7L15 1L13.5 2.5L16.75 5.75C14.4 6.1 12 7.65 12 10.5V22H22V10.5C22 9.65 21.65 9 21 9M11 22H2V10.5C2 7.65 4.6 6.1 6.25 5.75L9.5 2.5L8 1L2 7V9C1.35 9 1 9.65 1 10.5V22H11Z" />
                                                </svg>
                                            );
                                        case 'corporate':
                                            return (
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                                </svg>
                                            );
                                        case 'graduation':
                                            return (
                                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z" />
                                                </svg>
                                            );
                                        case 'circumcision':
                                            return (
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4" />
                                                </svg>
                                            );
                                        default:
                                            return null;
                                    }
                                };

                                return (
                                    <button
                                        key={category.id}
                                        onClick={() => handleFilterChange(category.id)}
                                        className={`group relative px-5 py-3 rounded-xl font-semibold text-xs transition-all duration-300 transform hover:scale-105 hover:shadow-lg ${activeFilter === category.id
                                            ? 'bg-gradient-to-r from-primary-600 to-primary-700 text-white shadow-md shadow-primary-500/25'
                                            : 'bg-white text-dark-700 hover:bg-gradient-to-r hover:from-primary-50 hover:to-primary-100 hover:text-primary-700 border border-gray-200 hover:border-primary-200'
                                            }`}
                                    >
                                        <div className="flex items-center space-x-2">
                                            <div className={`transition-colors duration-300 ${activeFilter === category.id ? 'text-white' : 'text-gray-400 group-hover:text-primary-600'
                                                }`}>
                                                <div className="w-4 h-4">
                                                    {getCategoryIcon(category.id)}
                                                </div>
                                            </div>
                                            <span>{category.name}</span>
                                            <div className={`px-2 py-0.5 rounded-full text-xs font-bold transition-all duration-300 ${activeFilter === category.id
                                                ? 'bg-white/20 text-white'
                                                : 'bg-gray-100 text-gray-600 group-hover:bg-primary-100 group-hover:text-primary-700'
                                                }`}>
                                                {category.count}
                                            </div>
                                        </div>

                                        {/* Aktif durumda alt çizgi */}
                                        {activeFilter === category.id && (
                                            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-1/2 h-1 bg-white rounded-t-full"></div>
                                        )}
                                    </button>
                                );
                            })}
                        </div>

                        {/* Mobile ve Tablet için kaydırılabilir kategori filtreleri */}
                        <div className="lg:hidden mb-4">
                            <div className="flex overflow-x-auto scrollbar-hide gap-3 px-4 pb-2">
                                {categories.map((category) => {
                                    const getCategoryIcon = (categoryId) => {
                                        switch (categoryId) {
                                            case 'all':
                                                return '🔍';
                                            case 'wedding-engagement':
                                                return '💍';
                                            case 'birthday':
                                                return '🎂';
                                            case 'henna':
                                                return '🤲';
                                            case 'corporate':
                                                return '🏢';
                                            case 'graduation':
                                                return '🎓';
                                            case 'circumcision':
                                                return '🌟';
                                            default:
                                                return '📱';
                                        }
                                    };

                                    return (
                                        <button
                                            key={category.id}
                                            onClick={() => handleFilterChange(category.id)}
                                            className={`flex-shrink-0 px-5 py-3 rounded-xl font-semibold text-sm transition-all duration-300 whitespace-nowrap ${activeFilter === category.id
                                                ? 'bg-gradient-to-r from-primary-600 to-primary-700 text-white shadow-lg'
                                                : 'bg-white text-dark-700 border border-gray-200 hover:border-primary-200 hover:bg-primary-50'
                                                }`}
                                        >
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">
                                                    {getCategoryIcon(category.id)}
                                                </span>
                                                <span>{category.name}</span>
                                                <div className={`px-2 py-0.5 rounded-full text-xs font-bold ${activeFilter === category.id
                                                    ? 'bg-white/20 text-white'
                                                    : 'bg-gray-100 text-gray-600'
                                                    }`}>
                                                    {category.count}
                                                </div>
                                            </div>
                                        </button>
                                    );
                                })}
                            </div>

                            {/* Kaydırma ipucu */}
                            <div className="text-center mt-2">
                                <p className="text-xs text-gray-500">
                                    👈 Kategoriler arasında kaydırarak gezin
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Çalışmalar Grid */}
            <section className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {currentWorks.map((work, index) => {
                            // Buğulanacak kategoriler: henna, graduation, circumcision
                            // Buğulanacak özel kartlar: Mehmet'in 30. Yaşı (ID: 8), Ayşe'nin 25. Yaşı (ID: 13), Ahmet'in 25. Yaşı (ID: 12), Startup Launch (ID: 9)
                            const isComingSoon = ['henna', 'graduation', 'circumcision'].includes(work.category) || [8, 9, 12, 13].includes(work.id);

                            return (
                                <div
                                    key={work.id}
                                    className={`group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden animate-slide-up relative ${isComingSoon ? 'pointer-events-none' : ''}`}
                                    style={{ animationDelay: `${index * 0.1}s` }}
                                >
                                    {/* Görsel Alanı */}
                                    {work.id === 1 ? (
                                        <div className="relative h-64 overflow-hidden">
                                            <img
                                                src={mehmetAyseImage}
                                                alt="Mehmet & Ayşe Düğün Davetiyesi"
                                                className="w-full h-full object-cover"
                                            />
                                            {/* Kategori Etiketi */}
                                            <div className="absolute top-4 right-4 bg-primary-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                                                {work.date}
                                            </div>
                                        </div>
                                    ) : work.id === 3 ? (
                                        <div className="relative h-64 overflow-hidden">
                                            <img
                                                src={birthdayImage}
                                                alt="Ayşe'nin Doğum Günü Davetiyesi"
                                                className="w-full h-full object-cover"
                                            />
                                            {/* Kategori Etiketi */}
                                            <div className="absolute top-4 right-4 bg-primary-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                                                {work.date}
                                            </div>
                                        </div>
                                    ) : work.id === 7 ? (
                        <div className="relative h-64 overflow-hidden">
                            <img
                                src={cansuAliImage}
                                alt={work.title}
                                className="w-full h-full object-cover"
                            />
                            {/* Kategori Etiketi */}
                            <div className="absolute top-4 right-4 bg-primary-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                                {work.date}
                            </div>
                        </div>
                                    ) : work.id === 11 ? (
                        <div className="relative h-64 overflow-hidden">
                            <img
                                src={ahmet15Image}
                                alt="Ahmet'in Doğum Günü Davetiyesi"
                                className="w-full h-full object-cover"
                            />
                            {/* Kategori Etiketi */}
                            <div className="absolute top-4 right-4 bg-primary-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                                {work.date}
                            </div>
                        </div>
                    ) : work.id === 5 ? (
                        <div className="relative h-64 overflow-hidden">
                            <img
                                src={eventImage2}
                                alt="Kurumsal Etkinlik 2025"
                                className="w-full h-full object-cover"
                            />
                            {/* Kategori Etiketi */}
                            <div className="absolute top-4 right-4 bg-primary-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                                {work.date}
                            </div>
                        </div>
                    ) : (
                                        <div className={`relative h-64 bg-gradient-to-br ${work.color} p-6 flex items-center justify-center overflow-hidden`}>
                                            {/* Diğer kartlar için telefon mockup */}
                                            <div className={`relative ${isComingSoon ? 'filter blur-md' : ''}`}>
                                                <div className="bg-gradient-to-b from-dark-800 to-dark-900 rounded-[1.5rem] p-1.5 shadow-xl group-hover:shadow-2xl transition-all duration-500 transform group-hover:scale-105">
                                                    <div className="bg-white rounded-[1.2rem] overflow-hidden w-32 h-56 relative">
                                                        <div className={`bg-gradient-to-br ${work.color} h-full flex flex-col items-center justify-center p-3 text-center`}>
                                                            <div className="text-lg font-bold text-dark-900 mb-1">{work.title}</div>
                                                            <div className="text-xs text-dark-600 mb-3">{work.subtitle}</div>
                                                            <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center mb-3">
                                                                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                                                                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                                                                </svg>
                                                            </div>
                                                            <div className="bg-red-500 text-white px-3 py-1 rounded-full text-xs font-bold">
                                                                Görüntüle
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Çok Yakında Overlay */}
                                            {isComingSoon && (
                                                <div className="absolute inset-0 bg-black/30 backdrop-blur-[2px] flex items-center justify-center">
                                                    <div className="bg-white/95 backdrop-blur-sm px-6 py-3 rounded-xl shadow-lg border border-gray-200">
                                                        <div className="flex items-center space-x-2">
                                                            <svg className="w-5 h-5 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                            </svg>
                                                            <span className="text-dark-900 font-bold text-sm">Çok Yakında</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Kategori Etiketi */}
                                            <div className="absolute top-4 right-4 bg-primary-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                                                {work.date}
                                            </div>
                                        </div>
                                    )}

                                    {/* İçerik Alanı */}
                                    <div className={`p-6 relative ${isComingSoon ? 'filter blur-[3px] opacity-60' : ''}`}>
                                        <h3 className="text-xl font-bold text-dark-900 mb-2">{work.title}</h3>
                                        <p className="text-primary-600 font-semibold mb-3">{work.subtitle}</p>
                                        <p className="text-dark-600 text-sm mb-4 leading-relaxed">{work.description}</p>

                                        {/* Özellikler */}
                                        <div className="flex flex-wrap gap-2 mb-6">
                                            {work.features.map((feature, idx) => (
                                                <span
                                                    key={idx}
                                                    className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs font-medium"
                                                >
                                                    {feature}
                                                </span>
                                            ))}
                                        </div>

                                        {/* Butonlar */}
                                        <div className="flex gap-2">
                                            <button
                                                onClick={() => {
                                                    if (isComingSoon) return;
                                                    if (work.id === 1) { // Mehmet & Ayşe düğün davetiyesi
                                                        navigate('/wedding');
                                                    } else if (work.id === 6) { // Sınıf 2024 mezuniyet töreni
                                                        navigate('/graduate');
                                                    } else if (work.id === 7) { // Cansu & Ali düğün davetiyesi
                                                        navigate('/wedding2');
                                                    } else if (work.id === 2) { // Zeynep & Ali nişan töreni
                                                        navigate('/engagement');
                                                    } else if (work.id === 3) { // Ayşe'nin 2. Yaşı doğum günü
                                                        navigate('/birthday');
                                                    } else if (work.id === 11) { // Ahmet'in 15. Yaşı doğum günü
                                                        navigate('/birthday2');
                                                    } else if (work.id === 12) { // Ahmet'in 25. Yaşı retro doğum günü
                                                        navigate('/birthday3');
                                                    } else if (work.id === 13) { // Ayşe'nin 25. Yaşı zarif doğum günü
                                                        navigate('/birthday4');
                                                    } else if (work.id === 5) { // Tech Summit 2024 kurumsal etkinlik
                                                        navigate('/event');
                                                    }
                                                }}
                                                disabled={isComingSoon}
                                                className={`flex-1 py-2 px-3 rounded-lg transition-colors font-semibold text-sm ${isComingSoon
                                                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                                    : 'bg-primary-600 text-white hover:bg-primary-700'
                                                    }`}
                                            >
                                                Detayları Gör
                                            </button>
                                            <button
                                                onClick={() => {
                                                    if (isComingSoon) return;
                                                    if (work.id === 1) { // Mehmet & Ayşe düğün davetiyesi
                                                        window.open('https://www.shopier.com/38203344', '_blank');
                                                    } else if (work.id === 11) { // Ahmet'in 15. yaşı doğum günü davetiyesi
                                                        window.open('https://www.shopier.com/38205125', '_blank');
                                                    } else if (work.id === 3) { // Ayşe'nin 2. Yaşı doğum günü davetiyesi
                                                        window.open('https://www.shopier.com/38205063', '_blank');
                                                    } else if (work.id === 7) { // Cansu & Ali düğün davetiyesi
                                                        window.open('https://www.shopier.com/38204904', '_blank');
                                                    } else {
                                                        // Diğer davetiyeler için satın alma işlemi
                                                        alert(`${work.title} için satın alma işlemi başlatılıyor...`);
                                                    }
                                                }}
                                                disabled={isComingSoon}
                                                className={`flex-1 py-2 px-3 rounded-lg transition-colors font-semibold text-sm flex items-center justify-center gap-1 ${isComingSoon
                                                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                                    : 'bg-green-600 text-white hover:bg-green-700'
                                                    }`}
                                            >
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m8 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01" />
                                                </svg>
                                                Satın Al
                                            </button>
                                            <button
                                                disabled={isComingSoon}
                                                className={`py-2 px-3 rounded-lg transition-colors font-semibold text-sm ${isComingSoon
                                                    ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                                    }`}
                                            >
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* Sayfalama */}
                    {totalPages > 1 && (
                        <div className="flex justify-center items-center mt-12 space-x-3">
                            <button
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                                className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                            >
                                Önceki
                            </button>

                            <div className="flex space-x-2">
                                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                    <button
                                        key={page}
                                        onClick={() => setCurrentPage(page)}
                                        className={`w-10 h-10 rounded-lg font-semibold transition-all ${currentPage === page
                                            ? 'bg-primary-600 text-white'
                                            : 'bg-white text-gray-700 hover:bg-primary-50 border border-gray-300'
                                            }`}
                                    >
                                        {page}
                                    </button>
                                ))}
                            </div>

                            <button
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages}
                                className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                            >
                                Sonraki
                            </button>
                        </div>
                    )}
                </div>
            </section>


        </div>
    );
};

export default Works;